import { useEditorStore } from '../../store/editorStore';
import { PAGE_TEMPLATES } from '../../data/pageTemplates';

function ThumbnailPreview({ template }) {
  const { background, elements } = template.thumbnail;
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        paddingTop: '177.78%',
        background,
        borderRadius: 8,
        overflow: 'hidden',
      }}
    >
      <div style={{ position: 'absolute', inset: 0 }}>
        {elements.map((el, i) => (
          <div key={i} style={{ position: 'absolute', ...el.style }}>
            {el.text}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PageTemplatesPanel() {
  const addPage = useEditorStore((s) => s.addPage);
  const updatePageBackground = useEditorStore((s) => s.updatePageBackground);
  const addLayer = useEditorStore((s) => s.addLayer);
  const story = useEditorStore((s) => s.story);
  const activePageId = useEditorStore((s) => s.activePageId);

  function applyTemplateLayers(pageId, template) {
    updatePageBackground(pageId, template.page.background);
    template.page.layers.forEach((layerDef, i) => {
      addLayer(pageId, layerDef.data, {
        x: layerDef.transform.x,
        y: layerDef.transform.y,
        width: layerDef.transform.width,
        height: layerDef.transform.height,
        rotation: layerDef.transform.rotation ?? 0,
        opacity: layerDef.transform.opacity ?? 1,
        zIndex: layerDef.transform.zIndex ?? (i + 1),
      });
    });
  }

  function handleApply(template) {
    if (!story) return;

    const activePage = story.pages.find((p) => p.id === activePageId);
    if (activePage && activePage.layers.length === 0) {
      applyTemplateLayers(activePageId, template);
      return;
    }

    addPage(story.pages.length - 1);
    const newPageId = useEditorStore.getState().activePageId;
    if (!newPageId) return;
    applyTemplateLayers(newPageId, template);
  }

  return (
    <div className="p-2">
      <h3 className="panel-label mb-1">Page Templates</h3>
      <p className="text-xs mb-3" style={{ color: 'var(--t-muted)' }}>
        Click to apply to the current page, or adds a new page if current has content.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        {PAGE_TEMPLATES.map((template) => (
          <button
            key={template.id}
            onClick={() => handleApply(template)}
            className="text-left group"
            style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }}
            title={template.name}
          >
            <div
              style={{
                borderRadius: 8,
                overflow: 'hidden',
                border: '1.5px solid var(--t-border)',
                transition: 'border-color 0.15s, box-shadow 0.15s',
                boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--brand-primary)';
                e.currentTarget.style.boxShadow = '0 0 0 2px rgba(99,102,241,0.35)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--t-border)';
                e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.2)';
              }}
            >
              <ThumbnailPreview template={template} />
            </div>
            <p
              className="text-[10px] font-medium mt-1 text-center truncate"
              style={{ color: 'var(--t-muted)' }}
            >
              {template.name}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}
